import React from 'react';
import './Donations.css';

// Import required components
import { Donation, Heading } from '../../../components';
import { donations } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Donations = () => { 

  return (
    <section className='donations'>

      {/* Section heading */}
      <Heading title={'Our Donations'} subTitle={'Community Support'} />

      <Swiper

        modules={[Autoplay]} // Enable Autoplay feature
        spaceBetween={10} // Space between slides
        loop={true} // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints for Different Screen Sizes
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          1025: { slidesPerView: 3 }, // 3 slides for larger screens
        }}
      >

        {/* Map over the donations array to render each donation */}
        {donations.map((donation) => { 
          return (
            <SwiperSlide key={donation.id}>

              {/* Render individual Donation component */}
              <Donation donation={donation} />

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Donations